import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {AlertService} from '../../services/alert/alert.service';
import {
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {LoadingService} from '../../services/loading/loading.service';
import {BsModalRef, BsModalService, ModalModule} from 'ngx-bootstrap/modal';
import {
  ConfirmationModalComponent
} from '../../shared/common-components/confirmation-modal/confirmation-modal.component';
import {BsDatepickerConfig, BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {CarrierRateProcurementService} from '../../services/carrier-rate-procurement/carrier-rate-procurement.service';
import {takeWhile} from "rxjs/operators";
import {UserService} from "../../services/user/user.service";
import {BehaviorSubject} from "rxjs";
import {User} from "../../services/user/user";
import {PaginationComponent} from "../../shared/pagination/pagination.component";
import {RouterLink} from "@angular/router";
import {DatePipe, NgClass, NgFor, NgIf} from "@angular/common";
import {AgGridAngular} from "ag-grid-angular";
import {GridApi, GridOptions} from "ag-grid-community";
import moment from 'moment';
import {ButtonRendererComponent2} from "../document-management/btnrender";
import {DateRendererComponent} from "./date-renderer.component";

@Component({
    selector: 'app-iff-rates',
    templateUrl: './iff-rates.component.html',
    styleUrls: ['./iff-rates.component.css'],
    imports: [
        ModalModule,
        ReactiveFormsModule,
        BsDatepickerModule,
        DatePipe,
        NgClass,
        NgFor, NgIf, AgGridAngular
    ]
})
export class IffRatesComponent implements OnInit {
  @ViewChild('createRateModal') createRateModal: TemplateRef<any>;
  private observer$ = new BehaviorSubject(true);
  HHG = 'HHG';
  FRT = 'FRT';
  currentUser: User;
  searchList: { name: string, value: string }[] = [];
  searchFor: { name: string, value: string }[] = [
    {
      name: "Freight",
      value: "FRT"
    },
    {
      name: "Household Goods",
      value: "HHG"
    }
  ];
  searchForFrt: { name: string, value: string }[] = [
    {
      name: "Freight",
      value: "FRT"
    }
  ];
  searchForHHG: { name: string, value: string }[] = [
    {
      name: "Household Goods",
      value: "HHG"
    }
  ];

  iffRatesListDetails: any = [];
  public errorMessage = '';
  iffRateType: any = null;
  iffRateTypeFrt: any = null;
  title: any;
  updateDisabled = false;

  iffRateError = false;
  iffRateErrorMessage: any = null;

  private tmssloader;
  iffRateTypeSearchForm: UntypedFormGroup;
  iffRatesForm: UntypedFormGroup;
  message: string;
  openMinDate: any;
  isCreate: boolean;

  iffRateTypes: any[] = [
    {name: 'Freight', value: 'FRT'},
    {name: 'Household Goods', value:  'HHG'}
  ];

  iffMoveTypesFrt: any[] = [
    {name: 'General', value: 'General'},
    {name: 'SIT', value: 'SIT'}
  ];
  iffMoveTypes: any[] = [];
  iffMoveTypesHhg: any[] = [
    {name: 'All', value: 'All'},
    {name: 'HHG/POV', value: 'HHG'},
    {name: 'SIT', value: 'SIT'},
    {name: 'XTOS', value: 'XTOS'}
  ];
  iffTransportationTypes: any[] = [];
  frtTransportationTypes: any[] = [
    {name: 'General Freight LTL', value: 'General Freight LTL'},
    {name: 'General Freight TL', value: 'General Freight TL'}
  ];
  hhgTransportationTypes: any[] = [
    {name: 'All', value: 'All'},
    {name: 'General Domestic', value: 'General Domestic'},
    {name: 'General International', value: 'General International'},
    {name: 'Domestic Move Management', value: 'Domestic Movemanagement'},
    {name: 'International Move Management', value: 'International Movemanagement'},
  ];
  hhgTransportationXtosTypes: any[] = [
    {name: 'All', value: 'All'},
    {name: 'Basic Extended Storage', value: 'Basic Extended Storage'},
    {name: 'Climate Controlled Extended Storage', value: 'Climate Controlled Extended Storage'}
  ];
  datePickerConfig: Partial<BsDatepickerConfig>;

  modalRef: BsModalRef;
  modalRefHhg: BsModalRef;
  activeIffRate: any = null;

  /*ag grid options*/
  public rowClassRules: any;
  gridOptions: GridOptions = this.initializeGridOptions();
  frameworkComponents: any;
  public gridApi;
  public gridColumnApi;
  public overlayNoRowsTemplate;
  public columnDefs;
  public actionsColumnDef;
  public defaultColDef;
  public rowSelection;
  public rowData: any;

  getRowHeight(params) {
    return 35;
  }

  constructor(private carrierRateProcService: CarrierRateProcurementService,
              private fb: UntypedFormBuilder,
              private alertService: AlertService,
              private modalService: BsModalService,
              private userService: UserService,
              private loader: LoadingService) {
    this.createForm();

    this.iffRatesForm.controls['businessType'].setValue('');
    this.iffRatesForm.controls['moveType'].setValue('');
    this.iffRatesForm.controls['transportationType'].setValue('');
    this.iffRatesForm.controls['effectiveDate'].setValue('');
    // this.iffRatesForm.controls['expireDate'].setValue('');
    this.iffRatesForm.controls['rateInPercentage'].setValue(0);
    this.openMinDate = new Date();
    this.openMinDate.setDate(this.openMinDate.getDate());
    this.iffRatesForm.controls['iffRatesId'].setValue(0);
    this.datePickerConfig = Object.assign({},
      {
        containerClass: 'theme-dark-blue',
        showWeekNumbers: false,
        minDate: this.openMinDate,
        dateInputFormat: 'MM/DD/YYYY'
      });
    this.overlayNoRowsTemplate = '<span style="margin-top: 90px;">No results found. Please adjust your filters.</span>';
    this.frameworkComponents = {
      buttonRenderer: ButtonRendererComponent2
    };
    this.columnDefs = [
      {
        headerName: 'PickUp Date/Effective Date',
        field: 'effectiveDate',
        cellRenderer: DateRendererComponent,
        cellRendererParams: {
          onClick: this.editRate.bind(this)
        },
        filter: 'agTextColumnFilter',
        sortable: true,
      },
      {
        headerName: 'Expiration Date',
        field: 'expireDate',
        cellRenderer: params => {
          return  params.data.expireDate ? moment(params.data.expireDate).format('MM/DD/YYYY') : '';
        },
        filter: 'agTextColumnFilter',
        sortable: true,
      },
      {
        headerName: 'Rate Type',
        field: 'businessType'
      },
      {
        headerName: 'Move Type',
        field: 'moveType'
      },
      {
        headerName: 'Transportation Type',
        field: 'transportationType'
      },
      {
        headerName: 'Administrative Fee',
        field: 'rateInPercentage'
      },
      {
        headerName: 'Actions',
        field: 'actions',
        hide: true,
        cellRendererSelector: function (params) {
          const buttonRenderer = {
            component: 'buttonRenderer'
          };
          return params.data.businessType === 'FRT' && params.node.rowIndex === params.api.getDisplayedRowCount() - 1 ? buttonRenderer : null;
        },
        cellRendererParams: {
          onClick: this.deleteIFFRate.bind(this.rowData),
          label: 'Delete'
        }
      }
    ];
    this.defaultColDef = {
      sortable: true,
      resizable: true,
      autoHeight: true,
      filter: 'agTextColumnFilter',
      filterParams: {
        maxNumConditions : 1
      }
    };
    this.rowClassRules = {
      'font-sans-3xs': 'true'
    };
  }

  editRate(selectedData) {
    this.createEdit('edit', 'createRateModal', selectedData);
  }

  private initializeGridOptions() {
    return <GridOptions>{
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      domLayout: 'autoHeight',
      rowHeight: 45
    };
  }
  createForm() {
    this.iffRateTypeSearchForm = this.fb.group({
      rateTypeSearch: new UntypedFormControl('', Validators.required)
    });
    this.iffRatesForm = this.fb.group({
      iffRatesId: new UntypedFormControl(''),
      createdUserId: new UntypedFormControl(''),
      createdDate: new UntypedFormControl(''),
      effectiveDate: new UntypedFormControl('', Validators.required),
      expireDate: new UntypedFormControl(''),
      businessType: new UntypedFormControl(''),
      moveType: new UntypedFormControl('', Validators.required),
      transportationType: new UntypedFormControl('', Validators.required),
      rateInPercentage: new UntypedFormControl('', Validators.pattern('^[0-9]+(.[0-9]{1,2})?$'))
    });

  }

  ngOnDestroy(): void {
    this.observer$.next(false);
  }

  ngOnInit() {
    // This to load all avilable IFF Rates
    // this.loadIFFRates();
    this.userService.getCurrentUserObservable().pipe(takeWhile(() => this.observer$.value)).subscribe(currentUser => {
      this.currentUser = currentUser;
      this.searchList = this.currentUser.permissions === this.HHG ? this.searchForHHG : this.currentUser.permissions === this.FRT ?
        this.searchForFrt : this.searchFor;
      if (this.searchList.length === 1) {
        this.onMasterListRateTypeChange(this.searchList[0].value);
      }
    });
  }

  // Rate type selection from  IFF Rates List screen.
  onMasterListRateTypeChange(rateTypeValue: string) {
    if (rateTypeValue !== null && rateTypeValue !== '') {
      this.iffRateType = rateTypeValue;
      this.iffRateTypeFrt = this.iffRateType === 'FRT';
      this.loadIFFRates();
    } else {
      this.iffRatesListDetails = [];
    }
  }

  // Rate type selection from Creat IFF Rate screen.
  onRateTypeChange(rateTypeValue: string) {
    this.iffTransportationTypes = [];
    this.iffMoveTypes = [];
    if (rateTypeValue === this.FRT) {
      this.iffTransportationTypes = this.frtTransportationTypes;
      this.iffMoveTypes = this.iffMoveTypesFrt;
    } else if (rateTypeValue === this.HHG) {
      // this.iffTransportationTypes = this.hhgTransportationTypes;
      this.iffMoveTypes = this.iffMoveTypesHhg;
    }
  }

  onHhgMoveTypeChange() {
    if (!this.iffRateTypeFrt) {
      const moveType = this.iffRatesForm.get('moveType').value;
      if (moveType === 'All') {
        this.iffRatesForm.get('transportationType').disable();
        this.iffRatesForm.updateValueAndValidity();
      } else {
        this.iffRatesForm.get('transportationType').enable();
        this.iffRatesForm.updateValueAndValidity();
        this.iffTransportationTypes = moveType === 'XTOS' ? this.hhgTransportationXtosTypes : this.hhgTransportationTypes;
      }
    }
  }

  // This is to load IFF Rates list.
  loadIFFRates() {
    this.iffRatesListDetails = [];
    this.iffRateError = false;
    this.iffRateErrorMessage = '';
    this.errorMessage = '';
    this.loader.show();
    // call to server for data.  Results will be rendered based on Business Type, Move Type and Transportation Type in iffRatesListDetails.
    this.carrierRateProcService.getIFFRatesList(this.iffRateType).subscribe(data => {
        this.iffRatesListDetails = data;
        this.rowData = this.iffRatesListDetails;
        this.toggleActionsColumn(this.gridApi);
      },
      (error) => {
        this.errorMessage = error;
        // console.log('No records loaded IFF Rates list: ' + error);
        this.loader.hide();
      }, () => {
        // console.log('Successfully retrieved IFF Rates list details: ', this.iffRatesListDetails);
        this.loader.hide();
      }
    );

  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setGridOption('headerHeight', 35);
    this.gridApi.sizeColumnsToFit();
    this.gridApi.sizeColumnsToFit();
    this.gridColumnApi = params.columnApi;
    const allColumnIds = [];
    this.gridColumnApi.getAllDisplayedColumns().forEach((column) => {
      allColumnIds.push(column.colId);
    });
    this.gridColumnApi.autoSizeColumns(allColumnIds, false);
  }

  toggleActionsColumn(api: GridApi) {
    const columnState = api.getColumnState();
    columnState.forEach((state) => {
      if (state.colId === 'actions') {
        state.hide = !this.iffRateTypeFrt;
      }
      api.applyColumnState({state: columnState});
    })
  }

  // read and set the form values, when modal gets opened
  createEdit(from?, modal?, iffRateRecord?) {
    if (from === 'create') {
      this.isCreate = true;
      this.title = 'Create IFF Rate';
      this.iffRatesForm.reset();
      if (this.iffRateType === null || this.iffRateType === '') {
        return this.alertService.error('Rate type cannot be blank. Please select Rate type.');
      } else {
        this.iffRatesForm.controls['businessType'].setValue(this.iffRateType);
        this.onRateTypeChange(this.iffRateType);
      }

      this.iffRatesForm.controls['effectiveDate'].setValue('');
      this.iffRatesForm.controls['expireDate'].setValue('');
      this.iffRatesForm.controls['moveType'].setValue('');
      this.iffRatesForm.controls['transportationType'].setValue('');
      this.iffRatesForm.controls['rateInPercentage'].setValue('');
      this.iffRatesForm.controls['createdUserId'].setValue('');
      this.iffRatesForm.controls['createdDate'].setValue('');
      this.iffRatesForm.controls['iffRatesId'].setValue('');
      this.updateDisabled = false;
      this.iffRateError = false;
      this.iffRateErrorMessage = '';
      modal.show();
    } else if (from === 'edit') {
      this.title = 'Update IFF Rate';
      this.isCreate = false;
      this.iffRatesForm.controls['businessType'].setValue(iffRateRecord.businessType);
      this.iffRatesForm.controls['effectiveDate'].setValue(new Date(iffRateRecord.effectiveDate));
      if (null === iffRateRecord.expireDate || '' === iffRateRecord.expireDate) {
        this.iffRatesForm.controls['expireDate'].setValue('');
      } else {
        this.iffRatesForm.controls['expireDate'].setValue(new Date(iffRateRecord.expireDate));
      }
      // this.iffRatesForm.controls['expireDate'].setValue(new Date(iffRateRecord.expireDate));
      this.iffRatesForm.controls['moveType'].setValue(iffRateRecord.moveType);
      if (iffRateRecord.businessType === 'FRT') {
        this.iffTransportationTypes = this.frtTransportationTypes;
      } else if (iffRateRecord.businessType === 'HHG') {
        this.iffTransportationTypes = this.hhgTransportationTypes;
      }
      this.iffRatesForm.controls['transportationType'].setValue(iffRateRecord.transportationType);
      this.iffRatesForm.controls['rateInPercentage'].setValue(iffRateRecord.rateInPercentage);
      this.iffRatesForm.controls['createdUserId'].setValue(iffRateRecord.createdUserId);
      this.iffRatesForm.controls['createdDate'].setValue(iffRateRecord.createdDate);
      this.iffRatesForm.controls['iffRatesId'].setValue(iffRateRecord.iffRatesId);
      this.updateDisabled = true;
      this.iffRateError = false;
      this.iffRateErrorMessage = '';
      this.modalService.show(this.createRateModal);
    }
  }

  // Function is used to create a new IFF Rate record.
  createIFFRate(formIffRate) {
    if(formIffRate.businessType === this.FRT)  this.validateDupeIffRecords(formIffRate, 'AddNew');
    if (!this.iffRateError) {
      this.carrierRateProcService.createIffRate(formIffRate).subscribe(IffRates => {
        if(formIffRate.businessType  === 'FRT') this.iffRatesListDetails = this.iffRatesListDetails.concat(IffRates);
        if(formIffRate.businessType  === 'HHG'){
          let hasExpiryDate = IffRates.filter((e: any) => e.expireDate !== null);
          let nonExpiryDate = IffRates.filter((e: any) => e.expireDate === null);
          for(let i = 0 ; i < hasExpiryDate.length ; i++){
            var foundIndex = this.iffRatesListDetails.findIndex((x: any) => x.iffRatesId == hasExpiryDate[i].iffRatesId);
            this.iffRatesListDetails[foundIndex] = hasExpiryDate[i];
          }
          this.iffRatesListDetails = this.iffRatesListDetails.concat(nonExpiryDate);
          this.rowData = this.iffRatesListDetails;
        }
        this.alertService.success('Successfully added new IFF Rate record.');
      }, (error) => {
        if(error?.status === 417)
          this.alertService.error(error?.error);
        else
          this.alertService.error("System Error, Please resubmit the Rate");
        this.loader.hide();
      }, () => {
        this.loader.hide();

      });
    }
  }

  // This is to update active IFF Rate record.
  updateIFFRate(formIffRate) {
    const formEffetiveDate = new Date(formIffRate.effectiveDate);
    formEffetiveDate.setHours(0, 0, 0, 0);

    let formExipreDate = null;
    if (formIffRate.expireDate === null || formIffRate.expireDate === '') {// If expire date is null, set to default end date: 12/31/2999.
      formExipreDate = new Date(2999, 11, 31);
      // this.iffRatesForm.controls['expireDate'].setValue(formExipreDate);
    } else {
      formExipreDate = new Date(formIffRate.expireDate);
    }
    formExipreDate.setHours(0, 0, 0, 0);

    if (formEffetiveDate > formExipreDate) {
      this.iffRateError = true;
      this.iffRateErrorMessage = 'Expire date cannot be less than Effective date';
    }
    if (!this.iffRateError) {
      if (formIffRate.carrierId !== null) {
        this.carrierRateProcService.createIffRate(formIffRate).subscribe(IffRates => {
          this.alertService.success('Successfully updated IFF Rate record.');
          this.loadIFFRates();
          this.loader.hide();
        }, (error) => {
          this.alertService.error(error);
          this.loader.hide();
        }, () => {
          this.loader.hide();

        });
      }
    }
  }

  // This is for date and dupe validations for all IFF Rate combination of Rate type, Transporation type and move type.
  validateDupeIffRecords(formIffRate, action) {
    let formEffetiveDate = null;
    let formExipreDate = null;
    let formBusinessType = null;
    let formMoveType = null;
    let formTransportationType = null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.iffRateError = false;

    formEffetiveDate = new Date(formIffRate.effectiveDate);
    formEffetiveDate.setHours(0, 0, 0, 0);
    if (formIffRate.expireDate === null || formIffRate.expireDate === '') {// If expire date is null, set to default end date: 12/31/2999.
      formExipreDate = new Date(2999, 11, 31);
      this.iffRatesForm.controls['expireDate'].setValue(formExipreDate);
    } else {
      formExipreDate = new Date(formIffRate.expireDate);
    }
    formExipreDate.setHours(0, 0, 0, 0);

    formBusinessType = formIffRate.businessType;
    if (formBusinessType === null || formBusinessType === '') {
      formBusinessType = this.iffRateType;
    }

    formMoveType = formIffRate.moveType;
    formTransportationType = formIffRate.transportationType;

    if (formEffetiveDate > formExipreDate) {// At any time, Effectie can't be greater than expire date
      this.iffRateError = true;
      this.iffRateErrorMessage = 'Effective date cannot be greater than Expire date';
    }
    if (today > formExipreDate && formEffetiveDate > today) {// If Active Record is already expired, then new Effective date cannot be greater than current date.
      this.iffRateError = true;
      this.iffRateErrorMessage = 'Effective date cannot be greater than Current date';
    }
    const isDuplicateExists = this.iffRatesListDetails.filter(x => x.businessType === formBusinessType && x.moveType === formMoveType
      && x.transportationType === formTransportationType);
    if (isDuplicateExists.length > 0) {
      if (this.dateRangeOverlaps(isDuplicateExists, formEffetiveDate, formExipreDate)) {
        this.iffRateError = true;
        this.iffRateErrorMessage = `Active IFF Rate exists for the combination of Rate Type ${formBusinessType}, Transportation Type ${formTransportationType}  and Move type ${formMoveType}. Please update and try again.`;
      }
    }
  }

  dateRangeOverlaps(iffRatesList: any, newEffectiveDt: any, newExpireDt: any) {
    let oldEffectiveDt = null;
    let oldExpireDt = null;
    this.activeIffRate = iffRatesList[iffRatesList.length - 1];
    oldEffectiveDt = new Date(this.activeIffRate.effectiveDate);
    oldEffectiveDt.setHours(0, 0, 0, 0);
    oldExpireDt = new Date(this.activeIffRate.expireDate);
    oldExpireDt.setHours(0, 0, 0, 0);
    if (oldEffectiveDt <= newEffectiveDt && newEffectiveDt <= oldExpireDt) {
      return true;
    } // b starts in a
    if (oldEffectiveDt <= newExpireDt && newExpireDt <= oldExpireDt) {
      return true;
    } // b ends in a
    if (newEffectiveDt <= oldEffectiveDt && oldExpireDt <= newExpireDt) {
      return true;
    } // a in b
    return false;
  }

  // Function is used to delete curent/active IFF Rate record
  deleteIFFRate(formIffRate) {
    if (formIffRate.carrierId !== null) {
      // User clicked Delete from the IFF Rate List
      this.modalRef = this.modalService.show(ConfirmationModalComponent);
      this.modalRef.content.question = 'Are you sure, you want to delete this IFF Rate?';
      this.modalRef.content.title = 'IFF RATE DELETE';
      this.modalRef.content.confirmText = 'Yes';
      this.modalRef.content.cancelText = 'No';
      this.modalRef.content.emitData.subscribe(result => {
        if (result.obj === true) {
          this.carrierRateProcService.deleteIffRate(formIffRate).subscribe(report => {
            this.alertService.success('Successfully Deleted IFF Rate record.');
            this.loadIFFRates();
            this.loader.hide();
          }, (error) => {
            this.alertService.error(error);
            this.loader.hide();
          }, () => {
            this.loader.hide();
          });
        }
      });
    }
  }
}
